<template>
  <div>
    <!-- В ProjectSmetaHub действия монтируются в липкую строку рядом с подвкладками -->
    <Teleport v-if="stickyActionsMountEl" :to="stickyActionsMountEl">
      <div class="tw-flex tw-items-end tw-gap-4 tw-flex-wrap">
        <CustomSelect
          :options="versions"
          label="Версия для сравнения"
          option-label-key="version_label"
          option-value-key="smeta_version_id"
          :value="selectedVersionId"
          @change="onVersionChange"
          placeholder="Выберите версию"
          :clearable="false"
          style="width: 300px;"
        />
        <q-btn
          color="primary"
          label="Загрузить"
          :disable="!selectedVersionId"
          :loading="loading"
          unelevated
          class="tw-h-[40px] tw-text-white tw-rounded-md tw-capitalize submit-btn"
          @click="load"
        />
        <q-btn
          v-if="showRestoreBtn"
          color="negative"
          unelevated
          class="tw-capitalize tw-text-white"
          :loading="restoring"
          @click="restoreSelected"
        >
          <q-icon name="restore" class="tw-mr-1" size="16px" />
          Перенести выбранные ({{ selectedKeys.size }})
        </q-btn>
      </div>
    </Teleport>
    <div v-else class="tw-flex tw-items-end tw-gap-4 tw-mb-6 tw-flex-wrap">
      <CustomSelect
        :options="versions"
        label="Версия для сравнения"
        option-label-key="version_label"
        option-value-key="smeta_version_id"
        :value="selectedVersionId"
        @change="onVersionChange"
        placeholder="Выберите версию"
        :clearable="false"
        style="width: 300px;"
      />
      <q-btn
        color="primary"
        label="Загрузить"
        :disable="!selectedVersionId"
        :loading="loading"
        unelevated
        class="tw-h-[40px] tw-text-white tw-rounded-md tw-capitalize submit-btn"
        @click="load"
      />
      <q-btn
        v-if="showRestoreBtn"
        color="negative"
        unelevated
        class="tw-capitalize tw-text-white"
        :loading="restoring"
        @click="restoreSelected"
      >
        <q-icon name="restore" class="tw-mr-1" size="16px" />
        Перенести выбранные ({{ selectedKeys.size }})
      </q-btn>
    </div>

    <div
      v-if="!loaded && !loading"
      style="padding: 40px; background: #f5f5f5; border-radius: 8px; text-align: center;"
    >
      <q-icon name="info" size="48px" color="grey-5" />
      <p style="color: #666; margin: 16px 0 0 0;">Выберите версию сметы и нажмите «Загрузить»</p>
    </div>

    <div v-else-if="loading" style="padding: 40px; text-align: center;">
      <q-spinner color="primary" size="3em" />
      <p style="color: #666; margin-top: 16px;">Загрузка сравнения...</p>
    </div>

    <div
      v-else-if="loaded && !rows.length"
      style="padding: 40px; background: #f5f5f5; border-radius: 8px; text-align: center;"
    >
      <q-icon name="check_circle" size="48px" color="green" />
      <p style="color: #666; margin: 16px 0 0 0;">Нет строк для сравнения — измените подъезд, этаж, вид сметы или версию</p>
    </div>

    <div
      v-else-if="loaded && rows.length"
      ref="restoreResultsRoot"
      class="cmp-restore-results"
    >
      <!-- Легенда + кнопка восстановления -->
      <div ref="versionLegend" class="version-legend">
        <div class="version-badge">
          <span class="dot dot--cur"></span>
          <span>Текущая смета (слева)</span>
        </div>
        <div class="ver-sep">↔</div>
        <div class="version-badge">
          <span class="dot dot--ver"></span>
          <span>Версия v{{ versionNo }} (справа) — {{ versionLabel }}</span>
        </div>
        <div class="legend-badges">
          <span class="badge badge--matched">Совпадают</span>
          <span class="badge badge--cur">Только в текущей</span>
          <span class="badge badge--ver">Только в версии</span>
        </div>
      </div>

      <!--
        Шапка: липкость на внешнем .cmp-thead-sticky (без overflow), чтобы top работал к viewport;
        тело: отдельный overflow-x, scrollLeft синхронизирован с шапкой.
      -->
      <div class="tbl-wrap">
        <div class="cmp-thead-sticky">
          <div
            class="tbl-sticky-x-head"
            ref="tblHeadScroll"
            @scroll="onTableXScroll('head', $event)"
          >
            <table class="cmp-table cmp-table--head">
              <colgroup>
                <col class="col-place" />
                <col class="col-name" />
                <col class="col-qty" />
                <col class="col-price" />
                <col class="col-sum" />
                <col class="col-cb-ver" />
                <col class="col-name" />
                <col class="col-qty" />
                <col class="col-price" />
                <col class="col-sum" />
              </colgroup>
              <thead>
                <tr>
                  <th rowspan="2" class="th-place">П / Эт</th>
                  <th colspan="4" class="th-side th-side--cur">Текущая смета</th>
                  <th colspan="5" class="th-side th-side--ver">Версия v{{ versionNo }}</th>
                </tr>
                <tr>
                  <th class="th-sub">Вид работы</th>
                  <th class="th-sub th-sub--r">Кол-во</th>
                  <th class="th-sub th-sub--r">Цена, тг</th>
                  <th class="th-sub th-sub--r">Сумма, тг</th>
                  <th class="th-cb th-cb--ver" title="Перенос в текущую смету" />
                  <th class="th-sub">Вид работы</th>
                  <th class="th-sub th-sub--r">Кол-во</th>
                  <th class="th-sub th-sub--r">Цена, тг</th>
                  <th class="th-sub th-sub--r">Сумма, тг</th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
        <div
          class="tbl-sticky-x-body"
          ref="tblBodyScroll"
          @scroll="onTableXScroll('body', $event)"
        >
          <table class="cmp-table cmp-table--body">
            <colgroup>
              <col class="col-place" />
              <col class="col-name" />
              <col class="col-qty" />
              <col class="col-price" />
              <col class="col-sum" />
              <col class="col-cb-ver" />
              <col class="col-name" />
              <col class="col-qty" />
              <col class="col-price" />
              <col class="col-sum" />
            </colgroup>
            <tbody>
              <template v-for="(item, idx) in flatList" :key="idx">

                <!-- Секция -->
                <tr v-if="item.type === 'section'" class="tr-section">
                  <td colspan="10" class="td-section">
                    <span :class="['sect-label', `sect-label--${item.section}`]">
                      {{ sectionLabel(item.section) }}
                    </span>
                    <label v-if="canSmetaRestore && item.section === 'version_only'" class="sect-check-all">
                      <input
                        type="checkbox"
                        :checked="isSectionAllSelected(item.section)"
                        @change="toggleSectionAll(item.section, $event.target.checked)"
                      />
                      <span>Выбрать все</span>
                    </label>
                  </td>
                </tr>

                <tr v-else-if="item.type === 'group'" class="tr-group">
                  <td colspan="10" class="td-group">{{ item.name || 'Без группы' }}</td>
                </tr>

                <!-- Строка работы -->
                <tr
                  v-else-if="item.type === 'row'"
                  :class="[rowClass(item.row), 'tr-expandable']"
                  @click="toggleExpand(item.row)"
                >
                  <td class="td-place">
                    П.{{ item.row.entrance }}<br>Эт.{{ item.row.level_num }}
                    <span class="td-expand-icon">
                      {{ expandedWorkRows[rowKey(item.row)] ? '▼' : '▶' }}
                    </span>
                  </td>
                  <td class="td-name" :class="{ 'td-empty': !item.showCur }">
                    <span v-if="item.showCur">{{ item.row.work_set_name }}</span>
                  </td>
                  <td class="td-num td-num--cur" :class="{ 'td-empty': !item.showCur }">
                    <span v-if="item.showCur && item.row.work_amount_current != null">
                      {{ formatAmount(item.row.work_amount_current) }}
                    </span>
                  </td>
                  <td class="td-num td-num--cur" :class="{ 'td-empty': !item.showCur }">
                    <Amount v-if="item.showCur && item.row.work_price_current != null"
                      :value="item.row.work_price_current" :round="2" />
                  </td>
                  <td class="td-sum td-sum--cur" :class="{ 'td-empty': !item.showCur }">
                    <Amount v-if="item.showCur && item.row.total_sum_current != null"
                      :value="item.row.total_sum_current" :round="2" />
                  </td>
                  <td
                    class="td-cb td-cb--ver"
                    :class="{ 'td-empty': item.row.section !== 'version_only' }"
                    @click.stop
                  >
                    <input
                      v-if="canSmetaRestore && item.row.section === 'version_only'"
                      type="checkbox"
                      :checked="selectedKeys.has(rowKey(item.row))"
                      @change="toggleRow(item.row, $event.target.checked)"
                    />
                  </td>
                  <td class="td-name" :class="{ 'td-empty': !item.showVer }">
                    <span v-if="item.showVer">{{ item.row.work_set_name }}</span>
                  </td>
                  <td class="td-num td-num--ver" :class="{ 'td-empty': !item.showVer }">
                    <span v-if="item.showVer && item.row.work_amount_version != null">
                      {{ formatAmount(item.row.work_amount_version) }}
                    </span>
                  </td>
                  <td class="td-num td-num--ver" :class="{ 'td-empty': !item.showVer }">
                    <Amount v-if="item.showVer && item.row.work_price_version != null"
                      :value="item.row.work_price_version" :round="2" />
                  </td>
                  <td class="td-sum td-sum--ver" :class="{ 'td-empty': !item.showVer }">
                    <Amount v-if="item.showVer && item.row.total_sum_version != null"
                      :value="item.row.total_sum_version" :round="2" />
                  </td>
                </tr>

                <!-- Строки материалов (раскрытые) -->
                <tr
                  v-else-if="item.type === 'material'"
                  :class="['tr-material', rowClass(item.parentRow)]"
                >
                  <td class="td-place td-mat-indent"></td>
                  <td class="td-name td-mat-name" :class="{ 'td-empty': !item.cur }">
                    <span v-if="item.cur" class="mat-name">{{ item.cur.material_name }}</span>
                    <span v-if="item.cur && item.cur.purchase_name" class="mat-purchase">
                      {{ item.cur.purchase_name }}
                    </span>
                  </td>
                  <td class="td-num td-num--cur" :class="{ 'td-empty': !item.cur }">
                    <span v-if="item.cur">{{ formatAmount(item.cur.material_amount) }}</span>
                  </td>
                  <td class="td-num td-num--cur" :class="{ 'td-empty': !item.cur }">
                    <Amount v-if="item.cur" :value="item.cur.material_price" :round="2" />
                  </td>
                  <td class="td-sum td-sum--cur" :class="{ 'td-empty': !item.cur }">
                    <Amount
                      v-if="item.cur"
                      :value="item.cur.material_amount * item.cur.material_price"
                      :round="2"
                    />
                  </td>
                  <td class="td-cb td-cb--ver td-empty"></td>
                  <td class="td-name td-mat-name" :class="{ 'td-empty': !item.ver }">
                    <span v-if="item.ver" class="mat-name">{{ item.ver.material_name }}</span>
                    <span v-if="item.ver && item.ver.purchase_name" class="mat-purchase">
                      {{ item.ver.purchase_name }}
                    </span>
                  </td>
                  <td class="td-num td-num--ver" :class="{ 'td-empty': !item.ver }">
                    <span v-if="item.ver">{{ formatAmount(item.ver.material_amount) }}</span>
                  </td>
                  <td class="td-num td-num--ver" :class="{ 'td-empty': !item.ver }">
                    <Amount v-if="item.ver" :value="item.ver.material_price" :round="2" />
                  </td>
                  <td class="td-sum td-sum--ver" :class="{ 'td-empty': !item.ver }">
                    <Amount
                      v-if="item.ver"
                      :value="item.ver.material_amount * item.ver.material_price"
                      :round="2"
                    />
                  </td>
                </tr>

              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSmetaVersions, getSmetaRestoreCompare, postSmetaRestoreCompareUpd, getHasGrant } from './services';
import Amount from '@/components/common/Amount.vue';
import CustomSelect from '@/components/form/CustomSelect';

export default {
  name: 'ProjectSmetaRestore',
  components: { Amount, CustomSelect },
  inject: {
    restoreStickyActionsHost: {
      from: 'restoreStickyActionsHost',
      default: () => () => null,
    },
  },
  props: {
    projectId:        { type: Number, required: true },
    projectEntranceId:{ type: [Number, null], default: null },
    floorMapId:       { type: [Number, null], default: null },
    what:             { type: String, default: 'general' },
  },
  data() {
    return {
      versions: [],
      selectedVersionId: null,
      rows: [],
      loading: false,
      loaded: false,
      restoring: false,
      // Set строк для восстановления: ключ = "work_set_id_work_set_check_group_id"
      selectedKeys: new Set(),
      // Храним полные row-объекты по ключу для отправки на бэкенд
      selectedRows: {},
      // Право M__ProjectSmetaRestore (в БД/админке: «Восстановление сметы»)
      canSmetaRestore: false,
      // Словарь раскрытых строк работ { key: true }
      expandedWorkRows: {},
      /** Якорь Teleport из ProjectSmetaHub; заполняется в mounted + $nextTick */
      stickyActionsMountEl: null,
      /** Смещение липкой шапки layout (совпадает с .smeta-sticky-top { top } в ProjectSmetaHub) */
      smetaStickyLayoutTopPx: 66,
      _restoreStickyObservers: null,
    };
  },
  computed: {
    versionInfo() {
      return this.versions.find((v) => v.smeta_version_id === this.selectedVersionId) || null;
    },
    versionNo() {
      return this.versionInfo?.version_no ?? '';
    },
    versionLabel() {
      if (!this.versionInfo) return '';
      return `${this.versionInfo.reason_name || 'без причины'} (${this.versionInfo.created_at})`;
    },
    showRestoreBtn() {
      return (
        this.canSmetaRestore
        && this.loaded
        && this.rows.length > 0
        && this.selectedKeys.size > 0
      );
    },
    hasRestoreTable() {
      return this.loaded && this.rows.length > 0;
    },
    /**
     * Разворачиваем rows в плоский список:
     * section-header → group-header → data rows → (material rows если раскрыто)
     */
    flatList() {
      const out = [];
      let prevSection = null;
      let prevGroupKey = null;

      for (const row of this.rows) {
        const section = String(row.section || '');

        // Заголовок секции
        if (section !== prevSection) {
          out.push({ type: 'section', section });
          prevSection = section;
          prevGroupKey = null;
        }

        // Заголовок группы
        const gk = `${section}_${row.work_set_check_group_id ?? ''}`;
        if (gk !== prevGroupKey) {
          out.push({ type: 'group', name: row.work_set_check_group_name });
          prevGroupKey = gk;
        }

        // Строка работы
        const showCur = section === 'matched' || section === 'current_only';
        const showVer = section === 'matched' || section === 'version_only';
        out.push({ type: 'row', row, showCur, showVer });

        // Строки материалов (если строка раскрыта)
        const key = this.rowKey(row);
        if (this.expandedWorkRows[key]) {
          const parseMats = (v) => {
            if (Array.isArray(v)) return v;
            if (typeof v === 'string') { try { return JSON.parse(v); } catch { return []; } }
            return [];
          };
          const matsCur = parseMats(row.materials_current);
          const matsVer = parseMats(row.materials_version);

          // FULL OUTER JOIN материалов по material_id
          const matMap = new Map();
          matsCur.forEach((m) => { matMap.set(m.material_id, { cur: m, ver: null }); });
          matsVer.forEach((m) => {
            if (matMap.has(m.material_id)) {
              matMap.get(m.material_id).ver = m;
            } else {
              matMap.set(m.material_id, { cur: null, ver: m });
            }
          });

          const sorted = [...matMap.values()].sort((a, b) => {
            const na = (a.cur || a.ver).material_name;
            const nb = (b.cur || b.ver).material_name;
            return na.localeCompare(nb, 'ru');
          });

          sorted.forEach(({ cur, ver }) => {
            out.push({ type: 'material', cur, ver, parentRow: row });
          });
        }
      }
      return out;
    },
  },
  watch: {
    what()             { this.resetState(); },
    projectId()        { this.loadVersions(); this.resetState(); },
    projectEntranceId(){ this.resetState(); },
    floorMapId()       { this.resetState(); },
    hasRestoreTable(val) {
      if (val) {
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.updateRestoreStickyStack();
            this.setupRestoreStickyObservers();
            this.syncTableHorizontalScroll();
            setTimeout(() => {
              this.updateRestoreStickyStack();
              this.syncTableHorizontalScroll();
            }, 300);
          });
        });
      } else {
        this.teardownRestoreStickyObservers();
      }
    },
  },
  methods: {
    /** Липкая легенда и thead: top под уже липкий ProjectSmetaHub.smeta-sticky-top */
    updateRestoreStickyStack() {
      const root = this.$refs.restoreResultsRoot;
      if (!root || !(this.loaded && this.rows.length)) return;

      const panel = this.$el.parentElement;
      const hubSticky = panel?.previousElementSibling;
      const hubH =
        hubSticky?.classList?.contains('smeta-sticky-top')
          ? hubSticky.offsetHeight
          : 0;

      const legendEl = this.$refs.versionLegend;
      const legendH = legendEl?.offsetHeight ?? 0;

      const topLegend = this.smetaStickyLayoutTopPx + hubH;
      const topThead0 = topLegend + legendH;

      root.style.setProperty('--rs-legend-top', `${topLegend}px`);
      root.style.setProperty('--rs-thead-r0-top', `${topThead0}px`);

      this.$nextTick(() => this.syncTableHorizontalScroll());
    },
    onTableXScroll(source, ev) {
      const t = ev?.target;
      if (!t || this._syncingXScroll) return;
      const other = source === 'head' ? this.$refs.tblBodyScroll : this.$refs.tblHeadScroll;
      if (!other) return;
      this._syncingXScroll = true;
      other.scrollLeft = t.scrollLeft;
      requestAnimationFrame(() => { this._syncingXScroll = false; });
    },
    /** После смены данных / layout выравниваем горизонтальный скролл (шапка = эталон). */
    syncTableHorizontalScroll() {
      const h = this.$refs.tblHeadScroll;
      const b = this.$refs.tblBodyScroll;
      if (!h || !b) return;
      if (this._syncingXScroll) return;
      this._syncingXScroll = true;
      b.scrollLeft = h.scrollLeft;
      requestAnimationFrame(() => { this._syncingXScroll = false; });
    },
    setupRestoreStickyObservers() {
      this.teardownRestoreStickyObservers();
      const panel = this.$el.parentElement;
      const hubSticky = panel?.previousElementSibling;

      let roHub = null;
      let roWin = null;
      if (hubSticky?.classList?.contains('smeta-sticky-top')) {
        roHub = new ResizeObserver(() => this.updateRestoreStickyStack());
        roHub.observe(hubSticky);
        roWin = () => this.updateRestoreStickyStack();
        window.addEventListener('resize', roWin);
      }

      let roLegend = null;
      if (typeof ResizeObserver !== 'undefined' && this.$refs.versionLegend) {
        roLegend = new ResizeObserver(() => this.updateRestoreStickyStack());
        roLegend.observe(this.$refs.versionLegend);
      }

      this._restoreStickyObservers = { roHub, roLegend, roWin };
    },
    teardownRestoreStickyObservers() {
      const o = this._restoreStickyObservers;
      if (!o) return;
      o.roHub?.disconnect();
      o.roLegend?.disconnect();
      if (o.roWin) window.removeEventListener('resize', o.roWin);
      this._restoreStickyObservers = null;
    },
    resetState() {
      this.rows = [];
      this.loaded = false;
      this.selectedKeys = new Set();
      this.selectedRows = {};
      this.expandedWorkRows = {};
    },
    toggleExpand(row) {
      const key = this.rowKey(row);
      const next = { ...this.expandedWorkRows };
      if (next[key]) { delete next[key]; } else { next[key] = true; }
      this.expandedWorkRows = next;
    },
    formatAmount(val) {
      if (val == null) return '';
      const n = Number(val);
      return isNaN(n) ? '' : n.toLocaleString('ru-RU', { maximumFractionDigits: 4 });
    },
    formatPrice(val) {
      if (val == null) return '';
      const n = Number(val);
      return isNaN(n) ? '' : n.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    rowKey(row) {
      const pe = row.project_entrance_id ?? 'x';
      const fm = row.floor_map_id ?? 'x';
      return `${pe}_${fm}_${row.work_set_id}_${row.work_set_check_group_id}`;
    },
    toggleRow(row, checked) {
      const key = this.rowKey(row);
      const newSet = new Set(this.selectedKeys);
      if (checked) {
        newSet.add(key);
        this.selectedRows[key] = row;
      } else {
        newSet.delete(key);
        delete this.selectedRows[key];
      }
      this.selectedKeys = newSet;
    },
    isSectionAllSelected(section) {
      const sectionRows = this.rows.filter((r) => r.section === section);
      if (!sectionRows.length) return false;
      return sectionRows.every((r) => this.selectedKeys.has(this.rowKey(r)));
    },
    toggleSectionAll(section, checked) {
      const newSet = new Set(this.selectedKeys);
      const newRows = { ...this.selectedRows };
      this.rows
        .filter((r) => r.section === section)
        .forEach((r) => {
          const key = this.rowKey(r);
          if (checked) {
            newSet.add(key);
            newRows[key] = r;
          } else {
            newSet.delete(key);
            delete newRows[key];
          }
        });
      this.selectedKeys = newSet;
      this.selectedRows = newRows;
    },
    async restoreSelected() {
      if (!this.canSmetaRestore) return;
      if (!this.selectedKeys.size) return;
      const items = Object.values(this.selectedRows).map((r) => ({
        work_set_id: r.work_set_id,
        work_set_check_group_id: r.work_set_check_group_id,
        project_entrance_id: r.project_entrance_id,
        floor_map_id: r.floor_map_id,
      }));
      const unique = Array.from(
        new Map(
          items.map((it) => [
            `${it.project_entrance_id}_${it.floor_map_id}_${it.work_set_id}_${it.work_set_check_group_id}`,
            it,
          ])
        ).values()
      );
      this.restoring = true;
      try {
        const res = await postSmetaRestoreCompareUpd(
          this.projectId,
          this.selectedVersionId,
          unique,
          this.projectEntranceId,
          this.floorMapId,
        );
        const count = res?.restored_count ?? 0;
        this.$q.notify({ type: 'positive', message: `Восстановлено записей: ${count}` });
        // Перезагружаем сравнение
        this.selectedKeys = new Set();
        this.selectedRows = {};
        await this.load();
      } catch (e) {
        const msg = e?.response?.data?.detail || e?.message || 'Ошибка при восстановлении';
        this.$q.notify({ type: 'negative', message: msg });
      } finally {
        this.restoring = false;
      }
    },
    sectionLabel(section) {
      if (section === 'matched')      return 'Совпадают в обеих сметах';
      if (section === 'version_only') return `Только в версии v${this.versionNo} — нет в текущей`;
      return `Только в текущей смете — нет в версии v${this.versionNo}`;
    },
    rowClass(row) {
      const s = String(row.section || '');
      if (s === 'matched')      return 'tr-matched';
      if (s === 'current_only') return 'tr-cur-only';
      if (s === 'version_only') return 'tr-ver-only';
      return '';
    },
    onVersionChange(value) {
      this.selectedVersionId = value;
      this.rows = [];
      this.loaded = false;
    },
    async loadVersions() {
      const res = await getSmetaVersions(this.projectId);
      if (res && res.length) {
        this.versions = res.map((v) => ({
          ...v,
          version_label: `v${v.version_no} — ${v.reason_name || 'без причины'} (${v.created_at})`,
        }));
        if (!this.selectedVersionId) {
          this.selectedVersionId = this.versions[0].smeta_version_id;
        }
      } else {
        this.versions = [];
        this.selectedVersionId = null;
      }
    },
    async load() {
      if (!this.selectedVersionId) return;
      this.loading = true;
      this.loaded = false;
      try {
        const data = await getSmetaRestoreCompare(
          this.projectId, this.selectedVersionId,
          this.projectEntranceId, this.floorMapId, this.what,
        );
        this.rows = Array.isArray(data) ? data : [];
        this.loaded = true;
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.$nextTick();
    const fn = this.restoreStickyActionsHost;
    this.stickyActionsMountEl = typeof fn === 'function' ? fn() || null : null;

    this.canSmetaRestore = await getHasGrant('M__ProjectSmetaRestore');
    await this.loadVersions();
  },
  unmounted() {
    this.teardownRestoreStickyObservers();
  },
};
</script>

<style scoped lang="scss">
/* Блок таблицы: CSS-переменные для липкой легенды/thead задаются в updateRestoreStickyStack */
.cmp-restore-results {
  --rs-legend-top: 132px;
  --rs-thead-r0-top: 182px;
}

/* Легенда */
.version-legend {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  position: sticky;
  top: var(--rs-legend-top);
  z-index: 20;
  margin-bottom: 0;
  padding: 10px 16px;
  background: #e3f2fd;
  border-radius: 8px 8px 0 0;
  border: 1px solid #e0e0e0;
  border-bottom: none;
  font-size: 13px;
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.12);
}
.version-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
}
.ver-sep { font-size: 20px; color: #aaa; }
.dot {
  width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0;
}
.dot--cur { background: #e65100; }
.dot--ver { background: #1565c0; }

.legend-badges {
  display: flex;
  gap: 8px;
  margin-left: auto;
}
.badge {
  font-size: 11px;
  font-weight: 700;
  padding: 2px 10px;
  border-radius: 4px;
  letter-spacing: 0.03em;
}
.badge--matched { background: #c8e6c9; color: #1b5e20; }
.badge--cur     { background: #fff9c4; color: #f57f17; }
.badge--ver     { background: #ffcdd2; color: #b71c1c; }

/* Кнопка «Выбрать все» в заголовке секции */
.sect-check-all {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-left: 12px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  vertical-align: middle;
  color: #b71c1c;
  input[type='checkbox'] { cursor: pointer; accent-color: #b71c1c; }
}

/* Оболочка: без overflow, чтобы липкая шапка цеплялась к viewport; X-скролл — во вложенных блоках. */
.tbl-wrap {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-top: none;
  border-radius: 0 0 8px 8px;
}

/* Липкость на обёртке, не на th (иначе с overflow-x ломается при скролле страницы) */
.cmp-thead-sticky {
  position: sticky;
  top: var(--rs-thead-r0-top);
  z-index: 19;
  background: #fff;
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.1);
}

.tbl-sticky-x-head,
.tbl-sticky-x-body {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
}

/* Основная таблица */
.cmp-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  table-layout: fixed;

  col.col-place   { width: 72px; }
  col.col-name    { min-width: 160px; }
  col.col-qty     { width: 80px; }
  col.col-price   { width: 100px; }
  col.col-sum     { width: 120px; }
  col.col-cb-ver  { width: 32px; }
}

/* Шапка — колонка выбора на стороне версии (перед «Вид работы») */
.th-cb--ver {
  background: #e3f2fd;
  border: 1px solid #ddd;
  width: 32px;
  padding: 4px 2px;
}
.td-cb--ver {
  text-align: center;
  vertical-align: middle;
  input[type='checkbox'] { cursor: pointer; accent-color: #b71c1c; }
}
/* Фон чекбокс-колонки в духе строки */
.tr-matched   .td-cb--ver { background-color: #e8f5e9; }
.tr-cur-only  .td-cb--ver { background-color: #fffde7; }
.tr-ver-only  .td-cb--ver { background-color: #ffebee; }
.tr-matched   .td-cb--ver.td-empty  { background-color: #d7eedb !important; }
.tr-cur-only  .td-cb--ver.td-empty { background-color: #fff3b0 !important; }
.tr-ver-only  .td-cb--ver.td-empty { background-color: #ffd6d9 !important; }

/* Стык «шапка / тело» — две таблицы, одна визуальная граница */
.cmp-thead-sticky .cmp-table thead tr:last-child th {
  border-bottom: 1px solid #ddd;
}
.tbl-sticky-x-body .cmp-table tbody tr:first-child td {
  border-top: none;
}

.th-place {
  background: #f5f5f5;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
  padding: 6px 4px;
  border: 1px solid #ddd;
  vertical-align: middle;
}
.th-side {
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  padding: 6px 8px;
  border: 1px solid #ddd;
}
.th-side--cur { background: #fff3e0; color: #e65100; border-bottom: 2px solid #ffcc80; }
.th-side--ver { background: #e3f2fd; color: #1565c0; border-bottom: 2px solid #90caf9; }
.th-sub {
  font-size: 11px;
  font-weight: 500;
  text-align: left;
  padding: 4px 8px;
  background: #fafafa;
  border: 1px solid #ddd;
}
.th-sub--r { text-align: right; }

/* Секция */
.tr-section td { padding: 8px 10px 4px; border: none; background: transparent; }
.sect-label {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  padding: 2px 10px;
  border-radius: 4px;
}
.sect-label--matched      { background: #c8e6c9; color: #1b5e20; }
.sect-label--current_only { background: #fff9c4; color: #f57f17; }
.sect-label--version_only { background: #ffcdd2; color: #b71c1c; }

/* Группа */
.tr-group .td-group {
  padding: 5px 10px;
  font-weight: 700;
  font-size: 12px;
  color: #1a237e;
  background: #f0f4ff;
  border-top: 2px solid #c5cae9;
  border-bottom: 1px solid #c5cae9;
  border-left: none;
  border-right: none;
}

/* Строки данных — цвет фона */
.tr-matched   td { background-color: #e8f5e9; }   /* зелёный — совпадают */
.tr-cur-only  td { background-color: #fffde7; }   /* жёлтый — только в текущей */
.tr-ver-only  td { background-color: #ffebee; }   /* красный — только в версии */

/* Ячейки */
.cmp-table td {
  border: 1px solid #e0e0e0;
  padding: 5px 7px;
  vertical-align: middle;
}
.td-place {
  text-align: center;
  font-size: 11px;
  color: #555;
  white-space: nowrap;
}
.td-name {
  text-align: left;
  word-break: break-word;
}
.td-num {
  text-align: right;
  font-variant-numeric: tabular-nums;
  font-size: 11px;
  color: #374151;
}
.td-num--cur { color: #b34700; }
.td-num--ver { color: #1a4f8a; }

.td-sum {
  text-align: right;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
}
.td-sum--cur { color: #e65100; }
.td-sum--ver { color: #1565c0; }

/* Пустая ячейка (сторона отсутствует) — чуть темнее фона строки */
.td-empty {
  border-style: dashed !important;
}
.tr-matched .td-empty  { background-color: #d7eedb !important; }
.tr-cur-only .td-empty { background-color: #fff3b0 !important; }
.tr-ver-only .td-empty { background-color: #ffd6d9 !important; }

/* Строка работы — всегда кликабельная для раскрытия материалов */
.tr-expandable {
  cursor: pointer;
  &:hover td { filter: brightness(0.96); }
}
.td-expand-icon {
  display: block;
  font-size: 9px;
  color: #9ca3af;
  margin-top: 2px;
}

/* Строки материалов */
.tr-material td {
  padding: 3px 7px;
  font-size: 11px;
  border-color: rgba(0,0,0,0.06) !important;
}
.tr-matched   .tr-material td { background-color: #f0faf1; }
.tr-cur-only  .tr-material td { background-color: #fefce8; }
.tr-ver-only  .tr-material td { background-color: #fff5f5; }
/* tr-material inherits parent row class colors via CSS combinators — use direct bg */
.tr-material.tr-matched   td { background-color: #f0faf1 !important; }
.tr-material.tr-cur-only  td { background-color: #fefce8 !important; }
.tr-material.tr-ver-only  td { background-color: #fff5f5 !important; }

.td-mat-indent { border-left: 3px solid #c5cae9 !important; }

.td-mat-name {
  line-height: 1.3;
  vertical-align: top !important;
  padding: 4px 8px !important;
}
.mat-name {
  display: block;
  font-weight: 500;
  color: #374151;
}
.mat-purchase {
  display: block;
  font-size: 10px;
  color: #6b7280;
  margin-top: 1px;
  font-style: italic;
}
</style>
